import RequestHttp from '../index';
import SourceAddressBuilder from '../builder/sourceAddressBuilder';

class SourceAddress {
    constructor({ postalCode, houseNumber, street }) {
        this.postalCode = postalCode;
        this.houseNumber = houseNumber;
        this.city = '';
        this.country = 'BR';
        this.street = street;
        this.state = '';

        this.request = new RequestHttp('https://viacep.com.br/ws');
    }

    async init() {
        try {
            await this.searchAddress();

            const addressBuilder = new SourceAddressBuilder();

            const address = await addressBuilder
                .setPostalCode(this.postalCode)
                .setCity(this.city)
                .setCountry(this.country)
                .setStateOrProvince(this.state)
                .setStreet(this.street)
                .setHouseNumberOrName(this.houseNumber)
                .build();

            return address;
        } catch (error) {
            return error;
        }
    }

    async searchAddress() {
        try {
            const {
                localidade,
                logradouro,
                uf,
            } = await this.request.handleRequest({
                url: this.postalCode,
            });

            this.street = logradouro || this.street;
            this.city = localidade || 'Não Informado';
            this.state = uf || 'MG';
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}

export default SourceAddress;
